import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'

import { memo } from 'react'
import { ReportTempView } from './ReportTempView'

export const TemperatureDisplay = memo(
  ({ item }: { item: IBuffetGeneralReportResult }) => {
    const fallback =
      `${item.temperatureMin?.toFixed(2).replace('.', ',')}-` +
      `${item.temperatureAvg?.toFixed(2).replace('.', ',')}-` +
      `${item.temperatureMax?.toFixed(2).replace('.', ',')}`

    if (
      (item.standardTempMin || item.standardTempMin === 0) &&
      (item.standardTempMax || item.standardTempMax === 0)
    ) {
      return (
        <>
          <ReportTempView
            value={item.temperatureMin}
            min={item.standardTempMin}
            max={item.standardTempMax}
          />
          {item.temperatureAvg !== null && (
            <>
              {' - '}
              <ReportTempView
                value={item.temperatureAvg}
                min={item.standardTempMin}
                max={item.standardTempMax}
              />
            </>
          )}
          {item.temperatureMax !== null && (
            <>
              {' - '}
              <ReportTempView
                value={item.temperatureMax}
                min={item.standardTempMin}
                max={item.standardTempMax}
              />
            </>
          )}
        </>
      )
    }

    return <div style={{ minWidth: 150 }}>{fallback}</div>
  },
)
